import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Navigation from './components/Navigation'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import RewritePage from './pages/RewritePage'
import ProfilePage from './pages/ProfilePage'
import CommunityPage from './pages/CommunityPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import NotificationBell from './components/NotificationBell'
import useNotifications from './hooks/useNotifications'

// Main App Layout
const AppLayout = () => {
  const { user, loading } = useAuth()
  const { notifications, markAllRead } = useNotifications(user?.id)
  
  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-100 via-mint-100 to-peach-100 flex items-center justify-center">
        <div className="text-2xl font-bold text-primary-600">Loading...</div>
      </div>
    )
  }
  
  // Show login page if not authenticated
  if (!user) {
    return <LoginPage />
  }
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-mint-100 to-peach-100 font-sans">
      {/* Top bar with notification bell */}
      <header className="flex justify-between items-center px-4 py-2 shadow-sm bg-white/80 sticky top-0 z-40">
        <div className="text-2xl font-bold text-primary-600">🧠 Strangeminder</div>
        <NotificationBell notifications={notifications} onMarkAllRead={markAllRead} />
      </header>
      
      {/* Desktop Navigation */}
      <Navigation />
      
      <main className="pb-20 md:pb-0">
        <Routes future={{ v7_relativeSplatPath: true }}>
          <Route path="/" element={<HomePage />} />
          <Route path="/rewrite" element={<RewritePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  )
}

// Main App Component
const App = () => {
  return (
    <Router future={{ v7_relativeSplatPath: true }}>
      <AuthProvider>
        <AppLayout />
      </AuthProvider>
    </Router>
  )
}

export default App 